import { Badge } from '@ui/components/Badge';

import {
  ClockControlSettings,
  ClockControlType,
  TournamentMode,
  TournamentSystem,
} from '@features/shared/api/typings';
import { EventClockControl } from '@features/shared/ui/EventClockControl/EventClockControl';

type Props = {
  tournament?: {
    system: TournamentSystem;
    mode: TournamentMode;
    clockControl: ClockControlType;
    clockControlSettingsPlayer1: ClockControlSettings;
    clockControlSettingsPlayer2: ClockControlSettings;
  };
};

export function TournamentClockControlBadge({ tournament }: Props) {
  if (!tournament) return null;

  return (
    <Badge size="m" flat>
      <EventClockControl tournament={tournament} />
    </Badge>
  );
}
